"use client";

import { useEffect } from "react";

/**
 * Client-side Sentry init plus the Clerk API-outage monitor. Mount once in the
 * root layout so Sentry is live on every page.
 */
export function SentryInit() {
  useEffect(() => {
    import("../../instrumentation-client")
      .then((mod) => {
        if (mod.register) {
          mod.register();
        }
        // Install Clerk outage detector after Sentry is ready
        return import("@/lib/sentry/clerk-health-monitor").then(
          ({ installClerkHealthMonitor }) => {
            installClerkHealthMonitor();
            // Layer 1 of the LEV-536 bandaid: keep the Clerk session fresh on
            // preview/staging so the dev-instance 401 cascade never triggers
            // in the first place. No-op outside the preview env.
            return import("@/lib/clerk/preview-session-keepalive").then(
              ({ installPreviewClerkKeepalive }) => {
                installPreviewClerkKeepalive();
              },
            );
          },
        );
      })
      .catch(() => {
        // Chunk-load failure — silently degrade. Sentry and the Clerk monitor
        // are non-critical; the app functions without them.
      });
  }, []);

  return null;
}
